import React from "react";
import { Mail, Phone, MapPin, Clock, MessageSquare, Loader, Send } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactLocalService() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="10755" id="倾听你的声音" ref={ref} className={`py-20 bg-[#F7F7F7] transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {}
          <div className="space-y-10">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#4B4B4B]">
                倾听你的声音
              </h2>
              <p className="text-xl text-[#4B4B4B]/80 leading-relaxed">
                我们非常重视您的反馈，这能帮助听力通变得更好。无论是功能建议、程序错误还是您的赞美，我们都渴望听到。
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="mt-1 flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#58CC02]/10 text-[#58CC02]">
                  <Phone className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#4B4B4B]">技术支持</h3>
                  <p className="text-sm text-[#4B4B4B]/70 mb-1">周一至周五 10:00-18:00</p>
                  <Link to="tel:4001234567" className="text-xl font-bold text-[#58CC02] hover:text-[#46A302] transition-colors">
                    400-123-4567
                  </Link>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="mt-1 flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#1CB0F6]/10 text-[#1CB0F6]">
                  <Mail className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#4B4B4B]">反馈邮箱</h3>
                  <p className="text-sm text-[#4B4B4B]/70 mb-1">我们通常在 24 小时内回复</p>
                  <Link to="mailto:feedback@tinglitong.com" className="text-xl font-bold text-[#1CB0F6] hover:underline transition-all">
                    feedback@tinglitong.com
                  </Link>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="mt-1 flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-[#FFC800]/10 text-[#FFC800]">
                  <MapPin className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#4B4B4B]">官方社群</h3>
                  <p className="text-[#4B4B4B]/70">
                    加入我们的用户交流群，与数万名学习者一起进步。
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-[#E5E5E5]">
              <div className="flex flex-col sm:flex-row gap-6 items-center sm:items-start bg-white p-6 rounded-[24px] shadow-[0px_8px_24px_rgba(0,0,0,0.05)] border-2 border-[#E5E5E5]">
                <div className="shrink-0">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/wechat_qr_code_service.png" alt="听力通官方微信" className="h-32 w-32 rounded-[16px] border border-[#E5E5E5]" />
                </div>
                <div className="space-y-2 text-center sm:text-left">
                  <div className="flex items-center justify-center sm:justify-start gap-2 text-[#4B4B4B] font-bold text-lg">
                    <MessageSquare className="h-5 w-5 text-[#58CC02]" />
                    <span>听力通官方微信</span>
                  </div>
                  <p className="text-sm text-[#4B4B4B]/70">
                    扫描二维码添加小助手，获取最新功能资讯、学习干货及一对一帮助。
                  </p>
                  <p className="text-xs font-medium text-[#4B4B4B]/50">
                    在线时间：周一至周日 9:00-22:00
                  </p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="bg-white rounded-[32px] shadow-[0px_12px_32px_rgba(0,0,0,0.08)] border-2 border-[#E5E5E5] p-6 md:p-8 lg:p-10">
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#4B4B4B]">提交反馈</h3>
              <p className="text-[#4B4B4B]/70 mt-2">
                请填写以下表单，我们会认真阅读每一条来自用户的声音。
              </p>
            </div>

            <FormProvider formKey="voice_feedback" formId="voice_feedback" sectionName="feedback_section" defaultValues={{
            name: "",
            email: "",
            phone: "",
            order_number: "",
            message: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: false
            },
            order_number: {
              required: false
            },
            message: {
              required: true
            }
          }} submitText="提交反馈" successMessage="提交成功！感谢您对听力通的支持。" errorMessage="提交失败，请稍后重试。">
              <ContactForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center text-center py-12 space-y-4 animate-in fade-in zoom-in duration-300">
        <div className="h-20 w-20 bg-[#58CC02]/10 text-[#58CC02] rounded-full flex items-center justify-center mb-2">
          <Send className="h-10 w-10" />
        </div>
        <h4 className="text-2xl font-bold text-[#4B4B4B]">反馈已送达</h4>
        <p className="text-[#4B4B4B]/70 max-w-xs mx-auto">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 rounded-[16px] border-2 border-[#58CC02] text-[#58CC02] hover:bg-[#58CC02]/5 font-bold">
          再发一条
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="name" rules={{
        required: "请选择或填写反馈类型"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[#4B4B4B] font-bold">反馈类型 <span className="text-[#EE5555]">*</span></FormLabel>
              <FormControl>
                <input className="flex h-12 w-full rounded-[16px] border-2 border-[#E5E5E5] bg-transparent px-4 py-2 text-base placeholder:text-[#4B4B4B]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#58CC02] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-all" placeholder="程序错误 / 功能建议 / 赞美" {...field} />
              </FormControl>
              <FormMessage className="text-[#EE5555]" />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[#4B4B4B] font-bold">联系方式</FormLabel>
              <FormControl>
                <input type="tel" className="flex h-12 w-full rounded-[16px] border-2 border-[#E5E5E5] bg-transparent px-4 py-2 text-base placeholder:text-[#4B4B4B]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#58CC02] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-all" placeholder="手机号或微信号" {...field} />
              </FormControl>
              <FormMessage className="text-[#EE5555]" />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "请输入电子邮箱",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "请输入有效的邮箱地址"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[#4B4B4B] font-bold">电子邮箱 <span className="text-[#EE5555]">*</span></FormLabel>
            <FormControl>
              <input type="email" className="flex h-12 w-full rounded-[16px] border-2 border-[#E5E5E5] bg-transparent px-4 py-2 text-base placeholder:text-[#4B4B4B]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#58CC02] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-all" placeholder="example@email.com" {...field} />
            </FormControl>
            <FormMessage className="text-[#EE5555]" />
          </FormItem>} />

      <FormField control={control} name="order_number" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[#4B4B4B] font-bold">软件版本</FormLabel>
            <FormControl>
              <input className="flex h-12 w-full rounded-[16px] border-2 border-[#E5E5E5] bg-transparent px-4 py-2 text-base placeholder:text-[#4B4B4B]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#58CC02] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-all" placeholder="例如: v1.2.0" {...field} />
            </FormControl>
            <FormMessage className="text-[#EE5555]" />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "请输入详细反馈内容"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[#4B4B4B] font-bold">详细描述 <span className="text-[#EE5555]">*</span></FormLabel>
            <FormControl>
              <Textarea placeholder="请描述您遇到的问题或您的宝贵建议..." className="min-h-[140px] rounded-[16px] border-2 border-[#E5E5E5] bg-transparent px-4 py-3 text-base placeholder:text-[#4B4B4B]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#58CC02] focus-visible:border-transparent resize-y transition-all" {...field} />
            </FormControl>
            <FormMessage className="text-[#EE5555]" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-[#EE5555]/10 border-2 border-[#EE5555]/20 rounded-[16px] text-sm font-bold text-[#EE5555] animate-in fade-in slide-in-from-top-1">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 text-lg font-bold bg-[#58CC02] hover:bg-[#46A302] text-white rounded-[16px] shadow-[0px_4px_0px_0px_#46A302] active:shadow-none active:translate-y-[4px] transition-all">
        {isSubmitting ? <>
            <Loader className="mr-2 h-5 w-5 animate-spin" />
            正在提交...
          </> : "提交反馈"}
      </Button>
    </Form>;
}